var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatures3714C93E(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11597_15972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7427 7.46466V48.7603H5.32827V7.46466H17.7427ZM23.0631 0.344727H0.0078125V55.8802H23.0631V0.344727Z",
    fill: "#252117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6061 0.344727H25.5508V23.1285H48.6061V0.344727Z",
    fill: "#252117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2857 34.5208V48.7607H30.8712V34.5208H43.2857V34.5208ZM48.6061 27.4009H25.5508V55.8806H48.6061V27.4009Z",
    fill: "#252117"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11597_15972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.5935,
    height: 55.5355,
    fill: "white",
    transform: "translate(0.0117188 0.344727)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures3714C93E);
export default __webpack_public_path__ + "static/media/features.3714c93e.43136770020c462ca1ac4272bde8eca3.svg";
export { ForwardRef as ReactComponent };